import styled from "styled-components";

interface IContainerProps {
	isAbsolute?: boolean;
	colorBadge?: string;
}

export const Container = styled.div<IContainerProps>`
	background: ${({ theme, colorBadge }) => colorBadge || theme.pantone2726C};
	color: #fff;
	padding: 0.1rem 0.2rem;
	font-size: 0.6rem;
	border-radius: 2px;
	line-height: 0.7rem;

	${({ isAbsolute }) =>
		isAbsolute &&
		`
    position: absolute;
    top: 0;
    right: 4px;
    z-index: 1;
  `}
`;
